export default {
  meta: {
    title: "Basetao Spreadsheet: Produtos, Avaliações e Guia de Envio",
    description: "Recurso independente sobre Basetao Spreadsheet — encontre produtos, compare vendedores, verifique fotos QC, custos de envio e se a Basetao é legítima.",
  },
  brand: "Basetao Sheet",
  nav: {
    home: "Início",
    categories: "Categorias",
    shoppingGuide: "Guia de compras",
    readGuide: "Ler o guia",
    safety: "Segurança",
  },
  button: {
    buyNow: "Comprar agora",
    basetaoSpreadsheet: "Basetao Spreadsheet",
    readGuide: "Ler o guia",
    readArticle: "Ler o artigo completo",
    exploreCategories: "Explorar categorias",
    backHome: "Voltar ao início",
    visitMain: "Visitar site principal",
    viewAll: "Ver tudo",
  },
  cat: {
    shoes: "Sapatos",
    hoodies: "Moletons / Suéteres",
    tshirts: "Camisetas",
    jackets: "Jaquetas",
    pants: "Calças / Shorts",
    headwear: "Bonés e chapéus",
    sets: "Conjuntos",
    underwear: "Roupa íntima / Cuecas",
    jersey: "Camisas esportivas",
    accessories: "Acessórios",
    bags: "Bolsas",
    belts: "Cintos",
    perfumes: "Perfumes",
    other: "Outros itens",
  },
  notFound: {
    title: "Página não encontrada",
    desc: "A página que você procura não existe ou foi movida.",
  },
  footer: {
    tagline: "Recurso informativo independente sobre Basetao Spreadsheet.",
    quickLinks: "Links rápidos",
    categories: "Categorias",
    disclaimer: "Basetao Sheet é um recurso informativo independente e não é afiliado oficialmente à Basetao. As informações podem mudar e devem ser verificadas antes de comprar ou pagar.",
    allRights: "Todos os direitos reservados.",
  },
  articleMeta: {
    shortAnswerLabel: "Resposta curta",
    tocTitle: "Índice",
    checklistTitle: "Pontos-chave a verificar",
    faqTitle: "Perguntas frequentes",
    conclusionTitle: "Resumindo",
    authorLabel: "Autor",
    author: "Equipe editorial Basetao Sheet",
    publishedLabel: "Publicado",
    published: "2026",
    updatedLabel: "Atualizado",
    updated: "Agosto de 2026",
    disclaimer:
      "Basetao Sheet é um recurso informativo independente e não é afiliado oficialmente à Basetao. As informações podem mudar e devem ser verificadas antes de comprar ou pagar.",
  },
};